import React from 'react';

import * as styles from './Cover.css';

export interface ICoverProps {
  children: React.ReactNode;
}

export const Cover: React.FC<ICoverProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
